import { FC } from "react";
import styled from "styled-components";

import Button from "@/components/Button";

const StyledButton = styled(Button)`
  font-size: 11px;
  line-height: 12px;
  height: 27px;
  svg {
    border-radius: 50%;
  }
`;

interface Props {
  onOpenModal: () => void;
}

const AiButton: FC<Props> = ({ onOpenModal }) => {
  return (
    <StyledButton small color="colorized" onClick={onOpenModal}>
      <svg
        width="14"
        height="15"
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="7" cy="7.5" r="6.5" stroke="white" />
        <mask
          id="mask0_6769_230471"
          maskUnits="userSpaceOnUse"
          x="1"
          y="1"
          width="12"
          height="13"
        >
          <circle cx="7" cy="7.5" r="6" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_6769_230471)">
          <rect
            width="12"
            height="13"
            transform="translate(1 1)"
            fill="white"
          />
          <g filter="url(#filter0_f_6769_230471)">
            <path
              d="M6.85041 5.54439C8.56564 5.9466 8.68744 4.21781 10.0621 3.98064C14.9458 3.1381 15.409 14.8945 10.3841 16.6669C5.63003 18.3438 0.733547 8.70254 0.733547 8.70254C0.733547 8.70254 -0.212711 6.14822 0.733547 5.11512C1.58752 4.18279 2.70116 4.22795 3.92229 4.55555C4.88705 4.81437 5.87791 5.31634 6.85041 5.54439Z"
              fill="#4136CF"
            />
          </g>
          <g filter="url(#filter1_f_6769_230471)">
            <path
              d="M-12.4468 -3.33008C-9.92201 -2.73776 -9.74273 -5.28369 -7.71917 -5.63297C-0.530512 -6.87375 0.151409 10.4396 -7.24528 13.0498C-14.2432 15.5192 -21.4508 1.32084 -21.4508 1.32084C-21.4508 1.32084 -22.8436 -2.44084 -21.4508 -3.96225C-20.1937 -5.33527 -18.5545 -5.26877 -16.757 -4.78632C-15.3369 -4.40516 -13.8783 -3.66592 -12.4468 -3.33008Z"
              fill="#00B0FF"
            />
          </g>
          <g filter="url(#filter2_f_6769_230471)">
            <ellipse
              cx="3.29386"
              cy="18.9895"
              rx="8.52457"
              ry="8.51503"
              fill="#0038FF"
            />
          </g>
          <g filter="url(#filter3_f_6769_230471)">
            <path
              d="M-10.2694 12.2618C-11.2246 15.1178 -11.6425 17.2941 -10.2694 19.9739C-7.59232 25.1986 1.99508 25.1573 4.751 19.9739C6.92923 15.877 3.74928 12.5842 1.43469 8.56294C0.413391 6.78857 0.148552 5.30994 -1.64144 4.31851C-5.64694 2.09996 -8.81604 7.91639 -10.2694 12.2618Z"
              fill="#FF4880"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_f_6769_230471"
            x="-10.1603"
            y="-6.53582"
            width="34.5782"
            height="33.8719"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="5.23666"
              result="effect1_foregroundBlur_6769_230471"
            />
          </filter>
          <filter
            id="filter1_f_6769_230471"
            x="-32.5431"
            y="-16.1698"
            width="41.0123"
            height="39.9813"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="5.23666"
              result="effect1_foregroundBlur_6769_230471"
            />
          </filter>
          <filter
            id="filter2_f_6769_230471"
            x="-15.704"
            y="0.00111008"
            width="37.9957"
            height="37.9767"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="5.23666"
              result="effect1_foregroundBlur_6769_230471"
            />
          </filter>
          <filter
            id="filter3_f_6769_230471"
            x="-21.6227"
            y="-6.64293"
            width="37.5758"
            height="40.9932"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="5.23666"
              result="effect1_foregroundBlur_6769_230471"
            />
          </filter>
        </defs>
      </svg>
      Show
    </StyledButton>
  );
};

export default AiButton;
